import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/components/Login';
import Register from '@/components/Register';
import Dashboard from '@/components/Dashboard';
import AddRoom from '@/components/CreateNewRoom'
import Microscope from '@/components/Main'
import Images from '@/components/Images'
import Profile from '@/components/Profile'
import Title from '@/components/Title'


Vue.use(Router);

var prefix = process.env.routePrefix;

export default new Router({
	mode: 'history',
	routes: [
		{
            name: 'Login',
            path: '/login',
            alias: '/',
            component: Login
        },
        {
            name: 'Register',
            path: '/register',
            component: Register
        },
        {
            name: 'Dashboard',
            path: '/dashboard',
            component: Dashboard
        },
        {
            name: 'AddRoom',
            path: '/add-room',
            component: AddRoom
        },
        {
            name: 'Microscope',
            path: '/microscope',
            component: Microscope
        },
        {
            name: 'Images',
            path: '/images',
            component: Images
        },
        {
            name: 'Profile',
            path: '/profile',
            component: Profile
        },
        {
        name: 'Title',
        path: '/title',
        component: Title
        }
	]
})
